import {
    BackendSchema,
    IsActive,
    Rule,
    RuleSchemaType,
    RuleType,
} from "layouts/charging-rules/interface/Rules"

function isCheckboxInactive(options: Record<string, boolean>): boolean {
    return Object.values(options).every((v) => !v)
}

function isCheckboxCompany(options: Record<string, boolean>): boolean {
    return Object.values(options).every((v) => v)
}

function isNumberInactive(value: number | null): boolean {
    return value === null
}

function isNumberCompany(value: number | null): boolean {
    return value === 1
}

export function createInitialRules(
    schema: RuleSchemaType,
    companyRule: BackendSchema
): Rule[] {
    const rules: Rule[] = []
    if (schema.DOWBlocked) {
        let isActive: IsActive
        if (isCheckboxInactive(schema.DOWBlocked)) {
            isActive = IsActive.FALSE
        } else if (isCheckboxCompany(schema.DOWBlocked)) {
            isActive = IsActive.COMPANY
        } else {
            isActive = IsActive.TRUE
        }

        rules.push({
            type: RuleType.DOWBlocked,
            kind: "checkbox",
            isActive: isActive,
            options: { ...schema.DOWBlocked },
            defaultOptions: { ...(companyRule?.rules?.DOWBlocked ?? {}) },
        })
    }

    if (schema.HoursBlocked) {
        let isActive: IsActive
        if (isCheckboxInactive(schema.HoursBlocked)) {
            isActive = IsActive.FALSE
        } else if (isCheckboxCompany(schema.HoursBlocked)) {
            isActive = IsActive.COMPANY
        } else {
            isActive = IsActive.TRUE
        }
        rules.push({
            type: RuleType.HoursBlocked,
            kind: "checkbox",
            isActive: isActive,
            options: { ...schema.HoursBlocked },
            defaultOptions: { ...(companyRule?.rules?.HoursBlocked ?? {}) },
        })
    }

    if (schema.MaxRechargeDurationOptions) {
        let isActive: IsActive
        const value = schema.MaxRechargeDurationOptions.value
        if (isNumberInactive(value)) {
            isActive = IsActive.FALSE
        } else if (isNumberCompany(value)) {
            isActive = IsActive.COMPANY
        } else {
            isActive = IsActive.TRUE
        }

        rules.push({
            type: RuleType.MaxRechargeDurationOptions,
            kind: "number",
            isActive: isActive,
            value: schema.MaxRechargeDurationOptions.value,
            defaultValue:
                companyRule?.rules?.[RuleType.MaxRechargeDurationOptions]?.value ?? null,
        })
    }

    if (schema.MaxRechargeEnergyOptions) {
        let isActive: IsActive
        const value = schema.MaxRechargeEnergyOptions.value
        if (isNumberInactive(value)) {
            isActive = IsActive.FALSE
        } else if (isNumberCompany(value)) {
            isActive = IsActive.COMPANY
        } else {
            isActive = IsActive.TRUE
        }
        rules.push({
            type: RuleType.MaxRechargeEnergyOptions,
            kind: "number",
            isActive: isActive,
            value: schema.MaxRechargeEnergyOptions.value,
            defaultValue: companyRule?.rules?.[RuleType.MaxRechargeEnergyOptions]?.value ?? null,
        })
    }
    return rules
}